// Pages
import HomePage from './pages/HomePage';
import { ContentContextPage } from './pages/ContentContextPage';
import { ContentPage } from './pages/ContentPage';
import { QuestionsPage } from './pages/QuestionsPage';
import { AnswersPage } from './pages/AnswersPage';
import { NotificationConfigurationPage } from './pages/NotificationConfiguration';
import { UserListPage } from './pages/UsersListPage';
import { MediaPage } from './pages/MediaPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { SignedOutPage } from './pages/SignedOutPage';
import { VersionManagmentPage } from './pages/VersionManagmentPage';
import { QuestionnaireAnalyticsPage } from './pages/QuestionnaireAnalyticsPage';
import WeekLogAnalyticsPage from './pages/WeekLogAnalyticsPage';
import { BroadcastListPage } from './pages/BroadcastListPage';
import { BroadcastCreatePage } from './pages/BroadcastCreatePage';
import { BroadcastStatisticsPage } from './pages/BroadcastStatisticsPage';
import { SessionsPage } from './pages/SessionsPage';

// Router
import { Route, Routes } from 'react-router-dom';

// Auth
import { AuthProvider } from './auth/AuthProvider';
import { AuthorizedRoute } from './auth/AuthorizedRoute';
import { UserInfoProvider } from './auth/UserInfoProvider';
import { RoleProtectedRoute } from './auth/RoleProtectedRoute';
import { SIGNED_OUT_PATH } from './auth/signOut';

// Enums
import { DashboardUserRole } from './common/enums/DashboardUserRole';
import { TechnicalSupportPage } from './pages/TechnicalSupport';
import TechnicalSupportDetailsPage from './pages/TechnicalSupportDetailsPage';
import { QuestionnairePage } from './pages/QuestionnairePage';
import IstiftaPage from './pages/IstiftaPage';
import IstiftaDetailsPage from './pages/IstiftaDetailsPage';
import { IstiftaLinksPage } from './pages/IstiftaLinksPage';

function App() {
  return (
    <AuthProvider>
      <UserInfoProvider>
        <Routes>
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path={SIGNED_OUT_PATH} element={<SignedOutPage />} />
          <Route element={<AuthorizedRoute />}>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/questionnaire/:questionnaireId/analytics"
              element={<QuestionnaireAnalyticsPage />}
            />
            <Route
              path="/week-log-analytics"
              element={<WeekLogAnalyticsPage />}
            />
            <Route path="/content-context" element={<ContentContextPage />} />
            <Route path="/content" element={<ContentPage />} />
            <Route path="/questions" element={<QuestionsPage />} />
            <Route path="/answers" element={<AnswersPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/questionnaire" element={<QuestionnairePage />} />
            <Route
              path="/technical-support"
              element={<TechnicalSupportPage />}
            />
            <Route
              path="/technical-support/:id"
              element={<TechnicalSupportDetailsPage />}
            />
            <Route
              element={
                <RoleProtectedRoute
                  allowedRoles={[
                    DashboardUserRole.Sheikh,
                    DashboardUserRole.SuperAdmin,
                  ]}
                />
              }
            >
              <Route path="/istifta" element={<IstiftaPage />} />
              <Route path="/istifta/links" element={<IstiftaLinksPage />} />
              <Route path="/istifta/:id" element={<IstiftaDetailsPage />} />
            </Route>
            <Route
              element={
                <RoleProtectedRoute
                  allowedRoles={[DashboardUserRole.SuperAdmin]}
                />
              }
            >
              <Route path="/user-list" element={<UserListPage />} />
              <Route
                path="/versions-management"
                element={<VersionManagmentPage />}
              />
              <Route
                path="/notification-configuration"
                element={<NotificationConfigurationPage />}
              />
              <Route path="/broadcast" element={<BroadcastListPage />} />
              <Route
                path="/broadcast/create"
                element={<BroadcastCreatePage />}
              />
              <Route
                path="/broadcast/:id/stats"
                element={<BroadcastStatisticsPage />}
              />
              <Route path="/sessions" element={<SessionsPage />} />
            </Route>
          </Route>
        </Routes>
      </UserInfoProvider>
    </AuthProvider>
  );
}

export default App;
